export default "__VITE_ASSET__vyGuJHID__"